import { gql } from '@apollo/client';

export const GET_TEAM_TAB_DATA = gql`
  query GetTeamTabData($id: ID!) {
    baseProject(id: $id) {
      id
      budget {
        id
        fte
      }
      team {
        id
        location
        projectId
        type
        updatedAt
        members {
          id
          teamId
          slotId
          assignmentId
          employeeAlias
          positionId
          technologyId
          competencyLevel
          fte
          role
          isProbation
          isBackup
          isBench
          startDate
          endDate
          noteText
          createdAt
          updatedAt
        }
        expectedStructure {
          id
          teamId
          positionId
          technologyId
          competencyLevel
          requiredFte
          requiredRole
          description
        }
      }
      criticalPeriods {
        id
        projectId
        title
        description
        startDate
        endDate
        type
        createdBy
      }
      teamPlannedLeaves {
        id
        projectId
        employeeAlias
        startDate
        endDate
        comment
      }
      upcomingChanges {
        id
        projectId
        type
        status
        plannedStart
        plannedEnd
        isPrivate
        items {
          id
          upcomingChangeId
          fromEmployeeAlias
          toEmployeeAlias
          relatedAssignmentId
          comment
        }
        createdBy
        updatedBy
        createdAt
        updatedAt
      }
      assignments {
        id
        minPercent
        maxPercent
      }
    }
  }
`;
